export const releaseNoteQueryKeys = {
  all: ["release-notes"] as const,
  lists: () => [...releaseNoteQueryKeys.all, "list"] as const,
  list: (params?: Record<string, unknown>) =>
    [...releaseNoteQueryKeys.lists(), params] as const,
  details: () => [...releaseNoteQueryKeys.all, "detail"] as const,
  detail: (slug: string) => [...releaseNoteQueryKeys.details(), slug] as const,
  categories: () => [...releaseNoteQueryKeys.all, "categories"] as const,
};
